import { a as __extends, b as __awaiter, e as __generator, C as ClientSDKProxyContext, d as __assign, _ as __makeTemplateObject, g as __spread } from '../../chunks/chunk-525a49bc.js';
import { Tree, Spin } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT, a as ERROR_API_UNEXPECTED_RESULTS } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { d as defaultTheme, w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import { isEqual } from 'lodash';
import { a as applyThemeFontFamily, b as applyThemeFontSize, c as applyThemeListHighlight } from '../../chunks/chunk-ae1accbb.js';

var TreeNode = Tree.TreeNode;
var AssetTree = /** @class */ (function (_super) {
    __extends(AssetTree, _super);
    function AssetTree(props) {
        var _this = _super.call(this, props) || this;
        _this.autoPagingToArrayOptions = _this.props
            .autoPagingToArrayOptions
            ? _this.props.autoPagingToArrayOptions
            : { limit: Infinity };
        _this.loadAssetInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.client = this.context(AssetTreeWithTheme.displayName || '');
                if (!this.client) {
                    console.error(ERROR_NO_SDK_CLIENT);
                    return [2 /*return*/];
                }
                this.setState({ loading: true }, function () { return __awaiter(_this, void 0, void 0, function () {
                    var assetIds, assets, assetNodesMap, rootAssetNodes;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                assetIds = this.props.assetIds;
                                assets = [];
                                if (!assetIds) return [3 /*break*/, 3];
                                if (!(assetIds.length > 0)) return [3 /*break*/, 2];
                                return [4 /*yield*/, this.client.assets.retrieve(assetIds.map(function (id) { return ({ id: id }); }))];
                            case 1:
                                assets = _a.sent();
                                _a.label = 2;
                            case 2: return [3 /*break*/, 5];
                            case 3: return [4 /*yield*/, this.client.assets
                                    .list({
                                    filter: { root: true },
                                    aggregatedProperties: ['childCount'],
                                })
                                    .autoPagingToArray(this.autoPagingToArrayOptions)];
                            case 4:
                                assets = _a.sent();
                                _a.label = 5;
                            case 5:
                                assetNodesMap = AssetTree.convertAssetsToNodeMap(assets);
                                rootAssetNodes = Object.keys(assetNodesMap).map(Number);
                                this.setState({
                                    rootAssetNodes: rootAssetNodes,
                                    assetNodesMap: assetNodesMap,
                                    loading: false,
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        }); };
        _this.cursorApiRequest = function (assetId) { return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.assets
                            .list({
                            filter: { parentIds: [assetId] },
                            aggregatedProperties: ['childCount'],
                        })
                            .autoPagingToArray(this.autoPagingToArrayOptions)];
                    case 1:
                        result = _a.sent();
                        if (!result || !Array.isArray(result)) {
                            console.error(ERROR_API_UNEXPECTED_RESULTS);
                        }
                        return [2 /*return*/, result];
                }
            });
        }); };
        _this.onLoadData = function (treeNode) { return __awaiter(_this, void 0, void 0, function () {
            var eventKey, assetId, loadedKeys, updatedLoadedKeys, updatedAssetNode_1, assetChildren, mapUpdate_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        eventKey = treeNode.props.eventKey;
                        assetId = eventKey ? Number.parseInt(eventKey, 10) : undefined;
                        loadedKeys = this.state.loadedKeys;
                        updatedLoadedKeys = eventKey && !loadedKeys.includes(eventKey)
                            ? __spread(loadedKeys, [eventKey]) : loadedKeys;
                        if (!(!treeNode.props.children && assetId)) return [3 /*break*/, 2];
                        updatedAssetNode_1 = __assign({}, this.state.assetNodesMap[assetId]);
                        return [4 /*yield*/, this.cursorApiRequest(assetId)];
                    case 1:
                        assetChildren = _a.sent();
                        mapUpdate_1 = AssetTree.convertAssetsToNodeMap(assetChildren);
                        if (assetChildren.length) {
                            assetChildren.sort(function (a, b) { return a.name.localeCompare(b.name); });
                            updatedAssetNode_1.children = assetChildren.map(function (_a) {
                                var id = _a.id;
                                return id;
                            });
                        }
                        else {
                            updatedAssetNode_1.isLeaf = true;
                        }
                        this.setState(function (state) {
                            var _a;
                            return ({
                                assetNodesMap: __assign(__assign(__assign({}, state.assetNodesMap), (_a = {}, _a[assetId] = updatedAssetNode_1, _a)), mapUpdate_1),
                                loadedKeys: __spread(updatedLoadedKeys),
                            });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onSelectNode = function (title, key) {
            var assetId = Number.parseInt(key || '', 10);
            var _a = _this.state.assetNodesMap[assetId], node = _a.asset, isLeaf = _a.isLeaf;
            var onSelect = _this.props.onSelect;
            if (onSelect && key) {
                onSelect({ node: node, key: key, isLeaf: isLeaf, title: title });
            }
        };
        _this.onExpand = function (expandedKeys) {
            _this.setState({
                expandedKeys: AssetTree.toKeys(expandedKeys.map(function (key) { return Number.parseInt(key, 10); })),
            });
        };
        _this.renderTreeNode = function (nodeIds) {
            var styles = _this.props.styles;
            return nodeIds.map(function (assetId) {
                var node = _this.state.assetNodesMap[assetId];
                var children = node.children, asset = node.asset, isLeaf = node.isLeaf;
                return (node && (React.createElement(TreeNodeWrapper, { title: _this.getDisplayName(asset), key: asset.id, isLeaf: isLeaf, style: styles && styles.list }, children && _this.renderTreeNode(children))));
            });
        };
        _this.resetExpandedKeys = function () {
            _this.setState({ expandedKeys: {}, loadedKeys: [] });
        };
        _this.getDisplayName = function (asset) {
            var displayName = _this.props.displayName;
            if (displayName) {
                return displayName(asset);
            }
            return "" + asset.name + (asset.description ? ': ' + asset.description : '');
        };
        var defaultExpandedKeys = props.defaultExpandedKeys;
        _this.state = {
            loadedKeys: [],
            loading: true,
            rootAssetNodes: [],
            assetNodesMap: {},
            expandedKeys: AssetTree.toKeys(defaultExpandedKeys || []),
        };
        return _this;
    }
    AssetTree.convertAssetsToNodeMap = function (assets) {
        var nodes = {};
        assets.map(AssetTree.convertToNode).forEach(function (node) {
            nodes[node.asset.id] = node;
        });
        return nodes;
    };
    AssetTree.convertToNode = function (asset) {
        var isLeaf = asset.aggregates ? !asset.aggregates.childCount : false;
        return { asset: asset, isLeaf: isLeaf };
    };
    // TODO path?
    AssetTree.toKeys = function (path, initial) {
        if (initial === void 0) { initial = {}; }
        return path.reduce(function (acc, i) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[i] = true, _a)));
        }, initial);
    };
    AssetTree.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.loadAssetInfo();
                return [2 /*return*/];
            });
        });
    };
    AssetTree.prototype.componentDidUpdate = function (prevProps) {
        if (!isEqual(prevProps.assetIds, this.props.assetIds)) {
            this.resetExpandedKeys();
            this.loadAssetInfo();
        }
    };
    AssetTree.prototype.render = function () {
        var showLoading = this.props.showLoading;
        var _a = this.state, rootAssetNodes = _a.rootAssetNodes, expandedKeys = _a.expandedKeys, loading = _a.loading, loadedKeys = _a.loadedKeys;
        var _b = this, onLoadData = _b.onLoadData, onSelectNode = _b.onSelectNode, renderTreeNode = _b.renderTreeNode, onExpand = _b.onExpand;
        if (showLoading && loading) {
            return React.createElement(Spin, null);
        }
        return (React.createElement(Tree, { loadedKeys: loadedKeys, loadData: onLoadData, onSelect: function (_, e) {
                return onSelectNode(e.node.props.title, e.node.props.eventKey);
            }, expandedKeys: Object.keys(expandedKeys), onExpand: onExpand }, renderTreeNode(rootAssetNodes)));
    };
    AssetTree.contextType = ClientSDKProxyContext;
    AssetTree.defaultProps = {
        theme: __assign({}, defaultTheme),
    };
    return AssetTree;
}(Component));
var TreeNodeWrapper = styled(TreeNode)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  & span {\n    color: ", ";\n  }\n  & .ant-tree-node-selected {\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  & span {\n    color: ", ";\n  }\n  & .ant-tree-node-selected {\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return applyThemeFontFamily(theme.gearbox);
}, function (_a) {
    var theme = _a.theme;
    return applyThemeFontSize(theme.gearbox);
}, function (_a) {
    var theme = _a.theme;
    return theme.gearbox.textColor;
}, function (_a) {
    var theme = _a.theme;
    return applyThemeListHighlight(theme.gearbox);
});
var AssetTreeWithTheme = withDefaultTheme(AssetTree);
AssetTreeWithTheme.displayName = 'AssetTree';
var templateObject_1;

export { AssetTreeWithTheme as AssetTree, AssetTree as AssetTreeWithoutTheme };
